import n2words from 'n2words/lib/i18n/PL';

export function numberToWords(number) {
  if (number === 0) {
    return 'zero';
  }

  // break the number into the whole and digit parts
  const splittedValue = number.toString().split('.');

  // parse the whole part
  const wholePart = n2words(splittedValue[0]);

  // bring it all together and format the decimal part accordingly
  return splittedValue.length === 1 ? wholePart + ', ' + '00/100' : wholePart + ', ' + splittedValue[1] + '/100';
}
